export { default } from "./CookieConsentAppBar";
